<template>
  <Card
    :class="dealCardClassObject"
    class="DealCard"
  >
    <DealLowestPriceFlag v-if="deal.lowest" />

    <div class="row">
      <div class="col-12 col-xl-4 DealCard__block">
        <CardBasicInfoBlock
          :data="{
            name: deal.name,
            thumbnail: deal.provider.logo + '?q='+ timestamp,
            title: deal.provider.display_name,
            action: showSupplierDetails,
            actionText: $t('dealCardContactDetailsButton'),
          }"
        />
      </div>

      <div class="col-12 offset-xl-4  col-xl-4 DealCard__block">
        <DealPriceCard
          :price-value="deal.calculatedData.neto"
          :label="deal.calculatedData.totalAnnually"
          card-type="total"
          currency="€"
        />
      </div>

      <div class="col-12 DealCard__block">
        <DealDetailsTogglerButton @toggle="toggleDealDetails">
          {{ $t('dealCardDetailsButton') }}
        </DealDetailsTogglerButton>
      </div>

      <div
        v-if="dealDetailsVisible"
        class="col-12 DealCard__block"
      >
        <DealDetails :deal="deal" />
      </div>
    </div>

    <el-dialog
      :visible.sync="supplierDetailsIsVisible"
      :title="$t('contactDetailsPreviewModalTitle')"
      @update:visible="hideSupplierDetails"
    >
      <SupplierDetails :supplier="deal.provider" />
    </el-dialog>
  </Card>
</template>

<script>
import Vue from 'vue';
import { Dialog } from 'element-ui';
import Card from '@/components/Card.vue';
import CardBasicInfoBlock from '@/components/cardBasicInfo/Block.vue';
// Deal
import DealPriceCard from '@/components/deal/PriceCard.vue';
import DealDetailsTogglerButton
  from '@/components/deal/DetailsTogglerButton.vue';
import DealDetails from '@/components/deal/Details.vue';
import DealLowestPriceFlag from '@/components/deal/LowestPriceFlag.vue';
// Supplier
import SupplierDetails from '@/components/supplier/Details.vue';

Vue.use(Dialog);

export default {
  name: 'DealCard',
  components: {
    Card,
    CardBasicInfoBlock,
    DealPriceCard,
    DealDetailsTogglerButton,
    DealDetails,
    DealLowestPriceFlag,
    SupplierDetails,
  },
  props: {
    deal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dealDetailsVisible: false,
      supplierDetailsIsVisible: false,
    };
  },
  computed: {
    timestamp() {
      return Date.now();
    },
    dealCardClassObject() {
      return {
        'DealCard--lowest': this.deal.lowest,
      };
    },
    selectedLanguage() {
      return this.$i18n.locale();
    },
  },
  methods: {
    toggleDealDetails() {
      this.dealDetailsVisible = !this.dealDetailsVisible;
    },
    showSupplierDetails() {
      this.supplierDetailsIsVisible = true;
    },
    hideSupplierDetails() {
      this.supplierDetailsIsVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.DealCard {
  position: relative;
  animation: fadeIn 0.3s ease-in;
}
.DealCard--lowest {
  overflow: visible;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
    margin-top: -12px;
  }

  50% {
    opacity: 0.5;
    margin-top: -6px;
  }

  100% {
    opacity: 1;
    margin-top: 0;
  }
}
.CardBasicInfoBlock,
.DealPriceCard {
  height: 100%;
}
.DealDetailsTogglerButton {
  float: right;
  margin-top: 15px;
}

@include media-lg-max() {
  .DealCard__block {
    margin-top: 15px;

    &:first-child {
      margin-top: 0;
    }
  }
  .CardBasicInfoBlock {
    border-bottom: $borderSeparator--light;
    padding-bottom: 10px;
  }
  .DealDetailsTogglerButton {
    margin-top: 0;
  }
}
</style>
